var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"code",on:{"click":_vm.refreshCode}},[_c('Sdentify',{attrs:{"identifyCode":_vm.identifyCode}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }